import { useEffect, useState } from 'react';
import ExpenseCategoryAddModal from '../../components/enterprises/ExpenseCategoryAddModal';
import ExpenseCategoryListComponent from '../../components/enterprises/ExpenseCategoryListComponent';
import ExpenseGongjongAddModal from '../../components/enterprises/ExpenseGongjongAddModal';
import ExpenseGongjongListComponent from '../../components/enterprises/ExpenseGongjongListComponent';
import { getExpenseConfig, updateExpenseConfig } from '../../api/constlink';

interface ExpenseConfigContainerProps {
  enterpriseId: string;
}

function ExpenseConfigContainer({ enterpriseId }: ExpenseConfigContainerProps) {
  // const [alertMsg, setAlertMsg] = useState<any>();
  const [visibleExpenseCategoryAddModal, setVisibleExpenseCategoryAddModal] =
    useState(false);
  const [visibleExpenseGongjongAddModal, setVisibleExpenseGongjongAddModal] =
    useState(false);
  const [expenseConfig, setExpenseConfig] = useState<any>();

  useEffect(() => {
    (async () => {
      const _expenseConfig = await getExpenseConfig({ enterpriseId });
      setExpenseConfig(_expenseConfig);
    })();
  }, [enterpriseId]);

  const onDeleteExpenseCategory = async (name: string) => {
    const filteredCategories = expenseConfig.category.filter(
      (category: any) => category.name !== name,
    );
    const resExpenseConfig = await updateExpenseConfig({
      enterpriseId,
      data: { ...expenseConfig, category: filteredCategories },
    });
    setExpenseConfig(resExpenseConfig);
  };

  const onCreateExpenseCategory = async (category: any) => {
    const _categories = [...expenseConfig.category];
    _categories.push(category);
    const resExpenseConfig = await updateExpenseConfig({
      enterpriseId,
      data: { ...expenseConfig, category: _categories },
    });
    setExpenseConfig(resExpenseConfig);
    setVisibleExpenseCategoryAddModal(false);
  };

  const onDeleteExpenseGongjong = async (name: string) => {
    const filteredGongjong = expenseConfig.gongjong.filter(
      (gongjong: any) => gongjong.name !== name,
    );
    const resExpenseConfig = await updateExpenseConfig({
      enterpriseId,
      data: { ...expenseConfig, gongjong: filteredGongjong },
    });
    setExpenseConfig(resExpenseConfig);
    setVisibleExpenseGongjongAddModal(false);
  };

  const onCreateExpenseGongjong = async (gongjong: any) => {
    const _gongjongs = [...expenseConfig.gongjong];
    _gongjongs.push(gongjong);
    const resExpenseConfig = await updateExpenseConfig({
      enterpriseId,
      data: { ...expenseConfig, gongjong: _gongjongs },
    });
    setExpenseConfig(resExpenseConfig);
    setVisibleExpenseGongjongAddModal(false);
  };

  const closeExpenseCategoryAddModal = () => {
    setVisibleExpenseCategoryAddModal(false);
  };

  const openExpenseCategoryAddModal = () =>
    setVisibleExpenseCategoryAddModal(true);

  const closeExpenseGongjongAddModal = () => {
    setVisibleExpenseGongjongAddModal(false);
  };

  const openExpenseGongjongAddModal = () =>
    setVisibleExpenseGongjongAddModal(true);

  console.log(expenseConfig);

  return (
    <>
      {/* {alertMsg && (
        <Alert
          message={`${alertMsg.message}`}
          type={
            alertMsg.type === 'error'
              ? 'error'
              : alertMsg.type === 'warning'
              ? 'warning'
              : 'info'
          }
          closable
          style={{ marginTop: '5px', marginBottom: '5px' }}
        />
      )} */}
      {expenseConfig && (
        <ExpenseCategoryListComponent
          categories={expenseConfig.category.sort((a: any, b: any) =>
            a.name.localeCompare(b.name),
          )}
          onDelete={onDeleteExpenseCategory}
          openExpenseCategoryAddModal={openExpenseCategoryAddModal}
        />
      )}

      {expenseConfig && (
        <ExpenseGongjongListComponent
          gongjongs={expenseConfig.gongjong.sort((a: any, b: any) =>
            a.name.localeCompare(b.name),
          )}
          onDelete={onDeleteExpenseGongjong}
          openExpenseCategoryAddModal={openExpenseGongjongAddModal}
        />
      )}

      {visibleExpenseCategoryAddModal && expenseConfig && (
        <ExpenseCategoryAddModal
          visible={visibleExpenseCategoryAddModal}
          categories={expenseConfig.category}
          onCreate={onCreateExpenseCategory}
          onCancel={closeExpenseCategoryAddModal}
        />
      )}

      {visibleExpenseGongjongAddModal && expenseConfig && (
        <ExpenseGongjongAddModal
          visible={visibleExpenseGongjongAddModal}
          gongjongs={expenseConfig.gongjong}
          onCreate={onCreateExpenseGongjong}
          onCancel={closeExpenseGongjongAddModal}
        />
      )}
    </>
  );
}

export default ExpenseConfigContainer;
